const getDefaultState = () => ({
  allIds: [],
  byId: {}
});

const state = getDefaultState();

const getters = {
  find: state => id => state.byId[id],
  list: (state, getters) => state.allIds.map(id => getters.find(id))
};

const actions = {
  addOrderPackages: ({ commit }, orderPackages) => {
    orderPackages.forEach(op => {
      commit('add', op);
    });
  }
};

const mutations = {
  add: (state, orderPackage) => {
    state.byId[orderPackage.id] = orderPackage;
    if (state.allIds.includes(orderPackage.id)) return;
    state.allIds.push(orderPackage.id);
  },
  reset: state => Object.assign(state, getDefaultState())
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
};
